/* Combine Home — Wishlist Lists (multi-list system).
 * Substitui o wishlist flat do Shella por um sistema de múltiplas listas
 * nomeadas. Storage: localStorage por customer.
 * Não depende de nenhuma app externa (OList etc.).
 */
(function () {
  'use strict';

  var CUSTOMER_ID = window.CHWL_CUSTOMER_ID || null;
  var STORAGE_KEY = CUSTOMER_ID ? ('chwl-customer-' + CUSTOMER_ID) : 'chwl-guest';
  var LEGACY_KEY  = CUSTOMER_ID ? ('wishlist-customer-' + CUSTOMER_ID) : 'wishlist-guest';
  var DEFAULT_NAME = 'Favoritos';

  // ─── Storage ───────────────────────────────────
  function getLists() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var data = JSON.parse(raw);
      return Array.isArray(data.lists) ? data.lists : [];
    } catch (e) { return []; }
  }

  function saveLists(lists) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ lists: lists }));
    updateHeaderCount();
    updateHeartStates();
    document.dispatchEvent(new CustomEvent('chwl:updated'));
  }

  function migrateLegacy() {
    if (localStorage.getItem(STORAGE_KEY)) return;
    var raw = localStorage.getItem(LEGACY_KEY);
    if (!raw) return;
    var legacy;
    try { legacy = JSON.parse(raw); } catch (e) { return; }
    if (!Array.isArray(legacy) || !legacy.length) return;
    var items = [];
    legacy.forEach(function (item) {
      Object.keys(item).forEach(function (vid) {
        var handle = item[vid];
        if (handle && !items.some(function (i) { return i.handle === handle; })) {
          items.push({ variantId: String(vid), handle: handle });
        }
      });
    });
    saveLists([{
      id: makeId(),
      name: DEFAULT_NAME,
      createdAt: Date.now(),
      items: items
    }]);
  }

  function makeId() {
    return 'l_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
  }

  function totalCount() {
    var seen = {}, n = 0;
    getLists().forEach(function (l) {
      l.items.forEach(function (i) {
        if (!seen[i.handle]) { seen[i.handle] = 1; n++; }
      });
    });
    return n;
  }

  function isInAnyList(handle) {
    var lists = getLists();
    for (var i = 0; i < lists.length; i++)
      for (var j = 0; j < lists[i].items.length; j++)
        if (lists[i].items[j].handle === handle) return true;
    return false;
  }

  // ─── Header + heart states ─────────────────────
  function updateHeaderCount() {
    document.querySelectorAll('[data-js-wishlist-count]').forEach(function (el) {
      el.textContent = totalCount();
    });
  }

  function handleFromButton(btn) {
    // 1. Try nearest wrapper with data-product-handle
    var product = btn.closest('[data-product-handle]');
    if (product && product.getAttribute('data-product-handle')) {
      return product.getAttribute('data-product-handle');
    }
    // 2. Try [data-js-product] (may have handle in another attr)
    product = btn.closest('[data-js-product]');
    if (product) {
      var h = product.getAttribute('data-product-handle') || product.getAttribute('data-handle');
      if (h) return h;
    }
    // 3. Fallback: on product page, use pathname /products/{handle}
    var m = /\/products\/([^/?#]+)/.exec(location.pathname);
    if (m) return decodeURIComponent(m[1]);
    return null;
  }

  function updateHeartStates() {
    document.querySelectorAll('.js-store-lists-add-wishlist').forEach(function (btn) {
      var handle = handleFromButton(btn);
      if (!handle) return;
      if (isInAnyList(handle)) btn.setAttribute('data-button-status', 'added');
      else btn.removeAttribute('data-button-status');
    });
  }

  // ─── CRUD ──────────────────────────────────────
  function addToList(listId, variantId, handle) {
    var lists = getLists();
    var list = lists.find(function (l) { return l.id === listId; });
    if (!list) return false;
    if (list.items.some(function (i) { return i.handle === handle; })) return false;
    list.items.push({ variantId: String(variantId || ''), handle: handle });
    saveLists(lists);
    return true;
  }

  function removeFromList(listId, handle) {
    var lists = getLists();
    var list = lists.find(function (l) { return l.id === listId; });
    if (!list) return false;
    list.items = list.items.filter(function (i) { return i.handle !== handle; });
    saveLists(lists);
    return true;
  }

  function removeFromAllLists(handle) {
    var lists = getLists();
    lists.forEach(function (l) {
      l.items = l.items.filter(function (i) { return i.handle !== handle; });
    });
    saveLists(lists);
  }

  function createList(name) {
    if (!name || !String(name).trim()) return null;
    var lists = getLists();
    var newList = {
      id: makeId(),
      name: String(name).trim().slice(0, 60),
      createdAt: Date.now(),
      items: []
    };
    lists.push(newList);
    saveLists(lists);
    return newList;
  }

  function deleteList(listId) {
    var lists = getLists().filter(function (l) { return l.id !== listId; });
    saveLists(lists);
  }

  function renameList(listId, newName) {
    if (!newName || !String(newName).trim()) return false;
    var lists = getLists();
    var list = lists.find(function (l) { return l.id === listId; });
    if (!list) return false;
    list.name = String(newName).trim().slice(0, 60);
    saveLists(lists);
    return true;
  }

  function listsContainingHandle(handle) {
    return getLists().filter(function (l) {
      return l.items.some(function (i) { return i.handle === handle; });
    }).map(function (l) { return l.id; });
  }

  // ─── Popup ─────────────────────────────────────
  function ensurePopup() {
    var pop = document.getElementById('chwl-popup');
    if (pop) return pop;
    pop = document.createElement('div');
    pop.id = 'chwl-popup';
    pop.className = 'chwl-popup';
    pop.setAttribute('aria-hidden', 'true');
    pop.innerHTML =
      '<div class="chwl-popup__backdrop" data-chwl-close></div>' +
      '<div class="chwl-popup__panel" role="dialog" aria-modal="true">' +
        '<div class="chwl-popup__head">' +
          '<h3 class="chwl-popup__title">Selecione a lista</h3>' +
          '<button type="button" class="chwl-popup__close" data-chwl-close aria-label="Fechar">×</button>' +
        '</div>' +
        '<div class="chwl-popup__body">' +
          '<button type="button" class="chwl-popup__new-toggle" data-chwl-newtoggle>+ Criar nova lista</button>' +
          '<div class="chwl-popup__newrow" data-chwl-newrow style="display:none">' +
            '<input type="text" class="chwl-popup__newinput" placeholder="Nome da nova lista" maxlength="60" data-chwl-newname>' +
            '<button type="button" class="chwl-popup__newbtn" data-chwl-newsave>Criar</button>' +
          '</div>' +
          '<ul class="chwl-popup__lists" data-chwl-lists></ul>' +
        '</div>' +
        '<div class="chwl-popup__foot">' +
          '<button type="button" class="chwl-popup__submit" data-chwl-submit disabled>Adicionar</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(pop);

    // Event bindings
    pop.addEventListener('click', function (e) {
      if (e.target.closest('[data-chwl-close]')) closePopup();
      if (e.target.closest('[data-chwl-newtoggle]')) toggleNewRow(true);
      if (e.target.closest('[data-chwl-newsave]')) handleCreateNew();
      var radio = e.target.closest('[data-chwl-radio]');
      if (radio) selectListRadio(radio.value);
      if (e.target.closest('[data-chwl-submit]')) handleSubmit();
    });
    return pop;
  }

  var _popupCtx = { handle: null, variantId: null, selectedListId: null };

  function openPopup(handle, variantId) {
    var pop = ensurePopup();
    _popupCtx = { handle: handle, variantId: variantId, selectedListId: null };
    renderPopupLists();
    toggleNewRow(false);
    pop.classList.add('is-open');
    pop.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    var pop = document.getElementById('chwl-popup');
    if (!pop) return;
    pop.classList.remove('is-open');
    pop.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    _popupCtx = { handle: null, variantId: null, selectedListId: null };
  }

  function renderPopupLists() {
    var $ul = document.querySelector('[data-chwl-lists]');
    if (!$ul) return;
    var lists = getLists();
    var handle = _popupCtx.handle;
    var containing = listsContainingHandle(handle);

    if (!lists.length) {
      $ul.innerHTML = '<li class="chwl-popup__empty">Ainda não tem listas. Crie uma acima.</li>';
      updateSubmitBtn();
      return;
    }

    $ul.innerHTML = lists.map(function (l) {
      var inList = containing.indexOf(l.id) !== -1;
      var count = l.items.length;
      return (
        '<li class="chwl-popup__item">' +
          '<label class="chwl-popup__label">' +
            '<input type="radio" name="chwl-list" value="' + l.id + '" data-chwl-radio' + (inList ? ' data-in-list="1"' : '') + '>' +
            '<span class="chwl-popup__lname">' + esc(l.name) + '</span>' +
            '<span class="chwl-popup__lcount">' + count + '</span>' +
            (inList ? '<span class="chwl-popup__lbadge">Já adicionado</span>' : '') +
          '</label>' +
        '</li>'
      );
    }).join('');
    updateSubmitBtn();
  }

  function selectListRadio(listId) {
    _popupCtx.selectedListId = listId;
    updateSubmitBtn();
  }

  function updateSubmitBtn() {
    var btn = document.querySelector('[data-chwl-submit]');
    if (!btn) return;
    var lid = _popupCtx.selectedListId;
    var handle = _popupCtx.handle;
    if (!lid) { btn.disabled = true; btn.textContent = 'Adicionar'; return; }
    var containing = listsContainingHandle(handle);
    if (containing.indexOf(lid) !== -1) {
      btn.disabled = false;
      btn.textContent = 'Remover desta lista';
      btn.classList.add('is-remove');
    } else {
      btn.disabled = false;
      btn.textContent = 'Adicionar a esta lista';
      btn.classList.remove('is-remove');
    }
  }

  function toggleNewRow(show) {
    var row = document.querySelector('[data-chwl-newrow]');
    var toggle = document.querySelector('[data-chwl-newtoggle]');
    if (!row) return;
    row.style.display = show ? '' : 'none';
    if (toggle) toggle.style.display = show ? 'none' : '';
    if (show) {
      var input = row.querySelector('[data-chwl-newname]');
      if (input) { input.value = ''; setTimeout(function () { input.focus(); }, 30); }
    }
  }

  function handleCreateNew() {
    var input = document.querySelector('[data-chwl-newname]');
    if (!input) return;
    var name = input.value.trim();
    if (!name) return;
    var newList = createList(name);
    if (!newList) return;
    toggleNewRow(false);
    renderPopupLists();
    // Auto-select the new list
    var radio = document.querySelector('[data-chwl-radio][value="' + newList.id + '"]');
    if (radio) { radio.checked = true; selectListRadio(newList.id); }
  }

  function handleSubmit() {
    var lid = _popupCtx.selectedListId;
    var handle = _popupCtx.handle;
    var vid = _popupCtx.variantId;
    if (!lid || !handle) return;
    var containing = listsContainingHandle(handle);
    if (containing.indexOf(lid) !== -1) {
      removeFromList(lid, handle);
    } else {
      addToList(lid, vid, handle);
    }
    closePopup();
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ─── Intercept heart clicks ───────────────────
  function interceptClicks() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.js-store-lists-add-wishlist, .js-store-lists-remove-wishlist');
      if (!btn) return;
      // Skip clicks inside our own popup
      if (btn.closest('#chwl-popup')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var handle = handleFromButton(btn);
      var product = btn.closest('[data-js-product], [data-product-handle]');
      var vid = product && (product.getAttribute('data-product-variant-id') || '');
      if (!handle) return;
      openPopup(handle, vid);
    }, true); // capture — beat Shella's handler
  }

  // ─── Expose API for the wishlist page to use ──
  window.CHWL = {
    getLists: getLists,
    createList: createList,
    deleteList: deleteList,
    renameList: renameList,
    addToList: addToList,
    removeFromList: removeFromList,
    removeFromAllLists: removeFromAllLists,
    totalCount: totalCount,
    isInAnyList: isInAnyList,
    listsContainingHandle: listsContainingHandle,
    openPopup: openPopup,
  };

  // ─── Init ─────────────────────────────────────
  function init() {
    migrateLegacy();
    interceptClicks();
    updateHeaderCount();
    updateHeartStates();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
